export enum DropdownFilterVariant {
    Primary = "primary",
    Secondary = "secondary",
}

export enum SortingFilterEnum {
    MostRecent = "descending",
    LeastRecent = "ascending",
}
